// extracted by mini-css-extract-plugin
export default {"tiny":"modal-wrapper_tiny__vPhk4","small":"modal-wrapper_small__VojqW","medium":"modal-wrapper_medium__hxAzb","large":"modal-wrapper_large__Zp7rT","full":"modal-wrapper_full__ate7z"};